<template>
  <datePicker @input="onInput"
              :id="id"
              :type="type"
              :clearable="true"
              format="YYYY-MM-DD HH:mm:ss"
              :display-format="displayFormat"
              :value="insideValue"
              :placeholder="placeholder"
  />


</template>

<script>

	import VuePersianDatetimePicker from 'vue-persian-datetime-picker'

	export default {
		components: {
			datePicker: VuePersianDatetimePicker
		},
		props: {
			placeholder: {
				type: String
			},
			id: {
				type: String
			},
			displayFormat: {
				type: String,
				default: 'jYYYY-jMM-jDD'
			},
			type: {
				type: String,
				default: 'date'
			},
			toDate: {
				type: Boolean,
				default: false
			},
			value: {
				type: [String, undefined],
			},
			required: [Boolean, Function],
		},
		data() {
			return {
				item: this.value
			}
		},
		computed: {
			insideValue() {
				if (!this.value) {
					return undefined
				}
				let date = this.value
				date = new Date(date).getTime()
				const timeZoneOffset = new Date().getTimezoneOffset()
				let result = date + (60000 * Math.abs(timeZoneOffset))
				return new Date(result).toISOString()
			},
		},


		methods: {
			onInput(data) {
				if (!data) {
					return this.$emit('input', null)
				}

				let date = new Date(data).getTime()
        // console.log(date)
				// if (this.toDate)
				// 	date += date - 1000
        // console.log(new Date(data).toISOString())
        // console.log(new Date(date))
				const resultDate = new Date(date)
				return this.$emit('input', resultDate)
			}
		}
	}
</script>

<style lang="scss">

</style>
